class ProductStockValueModalController extends AbstractController
	@register()
	@inject '$uibModalInstance',
		'showStocks'
		'stockValues'
		'isVariant'
		'header'
		'reasonCodes'
		'onStockValueChange'
